import { cloneDeep } from 'lodash-es';
import { TAB_NAME_KEY_LIST, TAB_NAME_MAPPING } from '../constants';

export const formatTabName = (value?: string): string => {
  if (!value) return '';
  return TAB_NAME_MAPPING[value] || value;
};

export const sortTabs = (list?: string[] | null): string[] => {
  if (!Array.isArray(list) || list.length === 0) return [];
  const sortedList = cloneDeep(list);
  sortedList.sort((a, b) => {
    const aIndex = TAB_NAME_KEY_LIST.indexOf(a?.toLowerCase());
    const bIndex = TAB_NAME_KEY_LIST.indexOf(b?.toLowerCase());
    return aIndex - bIndex;
  });
  return sortedList;
};
